import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-title uppercase" }, "AZIONI MACCHINE", -1)
const _hoisted_4 = { class: "my-card mb-10" }
const _hoisted_5 = { class: "my-buttons my-card--body" }
const _hoisted_6 = { class: "border-solid border-2 rounded-lg flex-grow-0 w-full lg:w-10/12" }
const _hoisted_7 = { class: "my-form" }
const _hoisted_8 = { class: "my-form--field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "my-form--field--label" }, "Search term", -1)
const _hoisted_10 = { class: "my-form--field--field" }
const _hoisted_11 = { class: "my-form--field" }
const _hoisted_12 = { class: "my-form--field--field my-buttons" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reset ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Search ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            icon: "fas fa-search",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
          _ctx.typeSearch = 'machine';
        _ctx.showModalSearch = true;
                    }),
            class: _normalizeClass(
              _ctx.typeSearch === 'machine' && _ctx.searchTerm != ''
                ? 'is-success'
                : 'is-secondary'
            )
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Search " + _toDisplayString(_ctx.typeSearch === "machine" && _ctx.searchTerm != "" ? `: ${_ctx.searchTerm}` : ""), 1)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Button, {
            class: "is-secondary",
            icon: "fas fa-sync",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.refreshPage()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("common.aggiorna")), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_Table, {
            config: _ctx.configTableMachines,
            data: _ctx.searchTerm != '' &&
          _ctx.typeSearch === 'machine' ? _ctx.listMachinesFiltered : _ctx.listMachines
          }, null, 8, ["config", "data"])
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      isShowing: _ctx.showModalSearch,
      onCloseModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showModalSearch = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                class: "my-input",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchTerm) = $event))
              }, null, 512), [
                [_vModelText, _ctx.searchTerm]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-ban",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
            _ctx.listMachinesFiltered = _ctx.listMachines;
          _ctx.searchTerm = '';
          _ctx.typeSearch = '';
          _ctx.showModalSearch = false;
                          })
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "is-primary",
                icon: "fas fa-search",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {
            _ctx.searchMachines();
          _ctx.showModalSearch = false;
                          })
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShowing"])
  ], 64))
}